import React from 'react'
import PropTypes from 'prop-types'

import { isFunction } from '../../utils/fns'
import { useForm } from '../../utils/hooks'

import '../../globals/scss/components/multi-input-converter.scss'

const MultiInputConveter = (props) => {
  const { children, values } = props
  const formActions = useForm({
    ...values,
  })

  return (
    <div className="multiInputConveter">
      {children && isFunction(children) ? children({ ...formActions }) : null}
    </div>
  )
}

MultiInputConveter.propTypes = {
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
}

export default MultiInputConveter
